import CityServicePage from "@/pages/city-service/CityServicePage";
import { etobicokeFurnaceRepair } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={etobicokeFurnaceRepair} />; }
